@if (banner) {
  <div data-test="banner" class="banner" [ngClass]="showBanner ? 'slide-in': 'slide-out'">
    <div class="relative">
      <img [src]="banner" alt="banner" class="max-h-[300px] object-contain">
      @if (showBanner) {
        <div data-test="close-btn" (click)="showBanner = false" class="close">
          <cds-svg-icon [autofill]="false" name="cross"></cds-svg-icon>
        </div>
      }
    </div>
  </div>
}
